<%
/* One row of the board, declared once and called from each list below.
   A local function rather than an EJS `include`: the templates are bundled
   into the JS by esbuild, so there is no filesystem at runtime for `include`
   to resolve a partial against. Output inside the function appends to the same
   buffer as the rest of the template. */
function row( it ) { %>
  <div class="planitem<%= it.isUnavailable ? ' planitem--gone' : '' %>"
       data-item="<%= it.id %>" data-fixed="<%= it.isFixed ? '1' : '0' %>">
    <!-- The icon tile is a drag handle too — a far bigger target than the grip,
         and the part of the row a thumb naturally lands on. Only on movable
         rows: the stay markers are placed by the stay, so a check-out that
         follows the finger and then snaps back would be a lie about what
         happened. -->
    <span class="planitem__icon planitem__icon--<%= it.tone %>"<% if ( !it.isFixed ) { %> data-grip<% } %>><i class="icon icon--<%= it.icon %>"></i></span>
    <span class="planitem__text"<% if ( it.route ) { %> data-route="<%= it.route %>" role="link" tabindex="0"<% } %>>
      <span class="planitem__title"><%= it.title %></span>
      <span class="planitem__meta"><%= it.meta %></span>
      <% if ( it.dateNote ) { %>
        <span class="planitem__date<%= it.dateNote.warn ? ' planitem__date--warn' : '' %>">
          <i class="icon icon--<%= it.dateNote.warn ? 'triangle-alert' : 'calendar' %>"></i><%= it.dateNote.text %>
        </span>
      <% } %>
      <% if ( it.note ) { %><span class="planitem__note"><%= it.note %></span><% } %>
    </span>
    <% if ( it.isFixed ) { %>
      <i class="icon icon--lock planitem__lock" title="<%= _lcs( 'Gehört zu deinem Aufenthalt' ) %>"></i>
    <% } else { %>
      <!-- A second line under the text: at 44 × 44 px a touch target each, the
           controls no longer fit beside it on a phone (Funktionstest F13). The
           day picker is the alternative to dragging — choosing "Tag 2" is
           what a guest who cannot or will not drag wants to do. -->
      <span class="planitem__ctrls">
        <span class="planitem__day">
          <i class="icon icon--calendar"></i>
          <select data-id="item-day" aria-label="<%= _lcs( 'Tag wählen' ) %>">
            <option value=""<%= it.dayDate === null ? ' selected' : '' %>><%= _lcs( 'Noch ohne Tag' ) %></option>
            <% dayOptions.forEach( function( o ) { %>
              <option value="<%= o.date %>"<%= o.date === it.dayDate ? ' selected' : '' %>><%= o.label %></option>
            <% } ); %>
          </select>
          <i class="icon icon--chevron-down planitem__day-caret"></i>
        </span>
        <button class="planitem__ctrl planitem__grip" type="button" data-grip aria-label="<%= _lcs( 'Verschieben' ) %>"><i class="icon icon--grip-vertical"></i></button>
        <button class="planitem__ctrl" type="button" data-act="up"     aria-label="<%= _lcs( 'Nach oben' ) %>"<%= it.canUp ? '' : ' disabled' %>><i class="icon icon--chevron-up"></i></button>
        <button class="planitem__ctrl" type="button" data-act="down"   aria-label="<%= _lcs( 'Nach unten' ) %>"<%= it.canDown ? '' : ' disabled' %>><i class="icon icon--chevron-down"></i></button>
        <button class="planitem__ctrl planitem__ctrl--danger" type="button" data-act="remove" aria-label="<%= _lcs( 'Entfernen' ) %>"><i class="icon icon--x"></i></button>
      </span>
    <% } %>
  </div>
<% } %>
<div class="screen screen--plan">

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= _lcs( 'Dein Aufenthalt' ) %></p>
    <h1 class="screen__title"><%= _lcs( 'Mein Planer' ) %></h1>
    <p class="screen__sub"><%= board.rangeText %> · <%= board.nightsText %></p>
  </header>

  <!-- Which plan is open, and the two things you can do to it. A select rather
       than a row of pills: the guest may keep a dozen, and the native picker is
       a better list on a phone than anything scrolled sideways. -->
  <div class="planbar">
    <div class="planbar__select">
      <i class="icon icon--luggage"></i>
      <select data-id="plan-switch" aria-label="<%= _lcs( 'Reiseplan wählen' ) %>">
        <% plans.forEach( function( p ) { %>
          <option value="<%= p.id %>"<%= p.id === board.id ? ' selected' : '' %>><%= p.name %></option>
        <% } ); %>
      </select>
      <i class="icon icon--chevron-down planbar__caret"></i>
    </div>
    <button class="planbar__btn" type="button" data-act="edit" aria-label="<%= _lcs( 'Reiseplan bearbeiten' ) %>">
      <i class="icon icon--pencil"></i>
    </button>
    <button class="planbar__btn" type="button" data-act="new" aria-label="<%= _lcs( 'Neuen Reiseplan anlegen' ) %>">
      <i class="icon icon--plus"></i>
    </button>
  </div>

  <% if ( board.isPast ) { %>
    <p class="plan__note"><i class="icon icon--info"></i> <%= _lcs( 'Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.' ) %></p>
  <% } %>

  <!-- ============ Gemerkt, noch ohne Tag ============ -->
  <div class="section-head"><h3><%= _lcs( 'Gemerkt, noch ohne Tag' ) %></h3></div>
  <p class="plan__hint">
    <%= _lcs( 'Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.' ) %>
  </p>

  <!-- Same as the day lists: the prompt sits inside, so an emptied list is
       still something a row can be dragged back onto. Always rendered and
       hidden when it does not apply — a drag does not re-render the screen
       (see PlanState._onDragCommit), so the prompt has to be an element that
       is already there for the drop to reveal or conceal. -->
  <div class="planlist" data-drop="unsorted">
    <p class="planday__empty" data-empty<%= board.unsorted.length === 0 ? '' : ' hidden' %>><%= _lcs( 'Alles eingeplant. Neue Favoriten landen hier.' ) %></p>
    <% board.unsorted.forEach( row ); %>
  </div>

  <!-- ============ Tagesplanung ============ -->
  <div class="section-head"><h3><%= _lcs( 'Tagesplanung' ) %></h3></div>

  <% board.days.forEach( function( d ) { %>
    <section class="planday<%= d.isToday ? ' planday--today' : '' %>">
      <header class="planday__head">
        <span class="planday__label"><%= d.label %></span>
        <span class="planday__date"><%= d.dateText %></span>
        <% if ( d.isToday ) { %><span class="planday__badge"><%= _lcs( 'Heute' ) %></span><% } %>
      </header>
      <!-- Always rendered, even with nothing on it: an empty day is where the
           next thing gets dropped, and a day that is not drawn cannot be a
           drop target. The prompt lives INSIDE the list rather than after it,
           so an empty day is a box with real height to aim at — a `:empty`
           rule would not even match, since EJS leaves whitespace behind. -->
      <div class="planlist planlist--day" data-drop="<%= d.date %>">
        <p class="planday__empty" data-empty<%= d.items.length === 0 ? '' : ' hidden' %>><%= _lcs( 'Zieh eine Attraktion hierher.' ) %></p>
        <% d.items.forEach( row ); %>
      </div>
    </section>
  <% } ); %>

  <!-- ============ Empfehlungen ============ -->
  <% if ( board.suggestions.length > 0 ) { %>
    <div class="section-head"><h3><%= _lcs( 'Empfehlungen für deinen Zeitraum' ) %></h3></div>
    <div class="suggestlist">
      <% board.suggestions.forEach( function( s ) { %>
        <div class="suggest" data-suggest="<%= s.kind %>:<%= s.recordId %>">
          <span class="planitem__icon planitem__icon--<%= s.tone %>"><i class="icon icon--<%= s.icon %>"></i></span>
          <span class="planitem__text">
            <span class="planitem__title"><%= s.title %></span>
            <span class="planitem__meta"><%= s.meta %></span>
          </span>
          <button class="suggest__add" type="button" data-act="add" aria-label="<%= _lcs( '{title} zum Planer hinzufügen', { title: s.title } ) %>">
            <i class="icon icon--plus"></i> <%= _lcs( 'Hinzufügen' ) %>
          </button>
        </div>
      <% } ); %>
    </div>
  <% } %>

</div>
